/** Indexes into the flat Grid array. */
export const idx = (row, col) => row * 9 + col;
/** Returns the 3×3 box index (0–8) for a given cell. */
export const boxOf = (row, col) => Math.floor(row / 3) * 3 + Math.floor(col / 3);
